import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'activate-promocode-link',
  styleUrls: ['./activate-promocode-link.component.scss'],
  templateUrl: './activate-promocode-link.component.html',
})
export class ActivatePromocodeLinkComponent {

  @Input() promocode;
  @Input() short;

  @Output() addPromocode = new EventEmitter();
}
